import React, {useEffect, useState} from "react";
import logo from "../../resource/7.png";
import axios from "axios";
import CommonFormFields from "./CommonFormFields";
import Swal from "sweetalert2";
import apiClient from "@/api/client";

const DammaSermonsRequest = () => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        mobileNumber: "",
        wtNumber: "",
        email: "",
        date: "",
        time: "",
        count: "",
        option: "",
        birthday: false,
        sevenday: false,
        warming: false,
        threemonths: false,
        oneyear: false,
        annually: false,
        weddings: false,
    });

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const handleInputChange = (e) => {
        const {name, value, type, checked} = e.target;
        if (type === "checkbox") {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: checked,
            }));
        } else {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: value,
            }));
        }
    };

    useEffect(() => {
        const fetchIP = async () => {
            try {
                const response = await axios.get("https://api.ipify.org?format=json");
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    ip_address: response.data.ip, // Set the IP address
                }));
            } catch (error) {
                console.error("Error fetching IP address:", error);
            }
        };

        fetchIP();
    }, []);

    const validateForm = () => {
        const newErrors = {};

        // Validate First Name
        if (!formData.firstName) newErrors.firstName = "First Name is required";
        else if (!/^[A-Za-z]+$/.test(formData.firstName)) newErrors.firstName = "First Name should contain only letters";

        // Validate Last Name
        if (!formData.lastName) newErrors.lastName = "Last Name is required";
        else if (!/^[A-Za-z]+$/.test(formData.lastName)) newErrors.lastName = "Last Name should contain only letters";

        // Validate Mobile Number
        if (!formData.mobileNumber) newErrors.mobileNumber = "Mobile Number is required";
        else if (!/^\d{10}$/.test(formData.mobileNumber)) newErrors.mobileNumber = "Mobile Number should be 10 digits";

        // Validate Email
        if (!formData.email) newErrors.email = "Email is required";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = "Invalid email format";

        // Validate WT Number (assuming it's a string with specific format)
        if (!formData.wtNumber) newErrors.wtNumber = "WhatsApp Number is required";
        else if (!/^\d{10}$/.test(formData.wtNumber)) newErrors.wtNumber = "WhatsApp Number should be 10 digits";

        // Validate Date
        if (!formData.date) newErrors.date = "Date is required";

        // Validate Time
        if (!formData.time) newErrors.time = "Time is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateSelectionForm = () => {
        const { sevenday, threemonths, oneyear, annually, birthday, warming, weddings } = formData;

        // Check if at least one item is selected from the first group
        const isFirstGroupValid = sevenday || threemonths || oneyear || annually;

        // Check if at least one item is selected from the second group
        const isSecondGroupValid = birthday || warming || weddings;

        // If either group is not valid, return false
        if (!isFirstGroupValid || !isSecondGroupValid) {
            return false;
        }

        // If all validations pass, return true
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate the form
        const isValid = validateForm();
        if (!isValid) {
            // Show validation errors using Swal
            // const errorMessages = Object.values(errors).join("\n"); // Combine all error messages
            Swal.fire({
                icon: "error",
                title: "Validation Error",
                // text: errorMessages, // Display all validation errors
                text: "Check the form", // Display all validation errors
            });
            return; // Stop further execution
        }

        const IsvalidateSelectionForm = validateSelectionForm();
        if (!IsvalidateSelectionForm) {
            // Show validation errors using Swal
            Swal.fire({
                icon: "error",
                title: "Validation Error",
                text: "Please select at least one item under the Punyannumodana for the deceased.",
            });
            return; // Stop further execution
        }



        setLoading(true);

        try {
            // Make the API request
            const response = await apiClient.post('/sermon-request', formData);

            // Handle successful response
            console.log("Form submitted successfully:", response.data);
            Swal.fire({
                icon: "success",
                title: "Success!",
                text: "Form submitted successfully!",
            });

            // Reset the form
            setFormData({
                firstName: "",
                lastName: "",
                mobileNumber: "",
                wtNumber: "",
                email: "",
                date: null,
                time: "10:00",
                count: "",
                option: "",
                birthday: false,
                sevenday: false,
                warming: false,
                threemonths: false,
                oneyear: false,
                annually: false,
                weddings: false,
            });
        } catch (error) {
            // Handle API errors
            console.error("Error submitting form:", error);

            let errorMessage = "Something went wrong!";
            if (error.response) {
                // If the API returns an error response
                errorMessage = error.response.data.message || "An error occurred while submitting the form.";
            } else if (error.request) {
                // If the request was made but no response was received
                errorMessage = "No response from the server. Please try again later.";
            }

            // Show API error using Swal
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: errorMessage,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="form-page dark-gold ">
            <form onSubmit={handleSubmit}>
                <div className="form-title">
                    <img src={logo} alt="" width={200}/>
                    <div className="details">
                        <h1 className="font-second">Bhaddeka Vihari Monastery Center</h1>
                        <h2 className="h4">Dhamma Sermon at Home Request Form</h2>
                    </div>
                </div>

                <p className="font-p mt-6">
                    Please fill in the following details and we will contact you.
                </p>

                <CommonFormFields
                    formData={formData}
                    handleInputChange={handleInputChange}
                    errors={errors}
                />

                <p className="font-p mt-5">
                    Please indicate the date and time you wish to have the Dhamma Sermon{" "}
                </p>

                <div className="form-box mt-5">
                    <div className="form-item">
                        <input
                            type="date"
                            id="date"
                            name="date"
                            value={formData.date}
                            onChange={handleInputChange}
                            min={new Date().toISOString().split('T')[0]} // Set min to today's date
                        />
                        <label htmlFor="date">Date</label>
                        {errors.date && <span className="error">{errors.date}</span>}
                    </div>
                    <div className="form-item">
                        <input
                            type="time"
                            id="time"
                            name="time"
                            value={formData.time}
                            onChange={handleInputChange}
                        />
                        <label htmlFor="time">Time</label>
                        {errors.time && <span className="error">{errors.time}</span>}
                    </div>
                </div>

                <p className="font-p mt-5">
                    Please indicate if you have a preference of sanga member to perform the sermon.{" "}
                </p>

                <div className="form-box mt-5">
                    <div className="form-item">
                        <input type="text" id="count" name="count" value={formData.count} onChange={handleInputChange}/>
                    </div>
                </div>

                <p className="font-p mt-5">
                    Please indicate if you have any specific event or purpose for the
                    sermon
                </p>
                <p className="font-p mt-5">
                    Punyannumodana for the deceased
                </p>

                <div className="selection mt-5">
                    <div className="checkbox-box">
                        <label htmlFor="sevenday"> 7 Day</label>
                        <input
                            type="checkbox"
                            id="sevenday"
                            name="sevenday"
                            className="checkbox"
                            checked={formData.sevenday}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="checkbox-box">
                        <label htmlFor="threemonths"> 3 Months</label>
                        <input
                            type="checkbox"
                            id="threemonths"
                            name="threemonths"
                            className="checkbox"
                            checked={formData.threemonths}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="checkbox-box">
                        <label htmlFor="oneyear"> 1 Year</label>
                        <input
                            type="checkbox"
                            id="oneyear"
                            name="oneyear"
                            className="checkbox"
                            checked={formData.oneyear}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="checkbox-box">
                        <label htmlFor="annually"> Annually</label>
                        <input
                            type="checkbox"
                            id="annually"
                            name="annually"
                            className="checkbox"
                            checked={formData.annually}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>

                <div className="selection mt-5">
                    <div className="checkbox-box">
                        <label htmlFor="birthday"> Birthday</label>
                        <input
                            type="checkbox"
                            id="birthday"
                            name="birthday"
                            className="checkbox"
                            checked={formData.birthday}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="checkbox-box">
                        <label htmlFor="warming"> House Warming</label>
                        <input
                            type="checkbox"
                            id="warming"
                            name="warming"
                            className="checkbox"
                            checked={formData.warming}
                            onChange={handleInputChange}
                        />
                    </div>


                    <div className="checkbox-box">
                        <label htmlFor="weddings">Weddings Anniversary</label>
                        <input
                            type="checkbox"
                            id="weddings"
                            name="weddings"
                            className="checkbox"
                            checked={formData.weddings}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>


                <div className="form-box1 mt-5">
                    <div className="form-item1">
                        <label htmlFor="#">Other (Please specify)</label>
                        <input
                            type="text"
                            id="option"
                            name="option"
                            value={formData.option}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>

                <button type="submit" id="submitbtn" className="mt-5" disabled={loading}>
                    {loading ? "Submitting..." : "Submit"}
                </button>

                <p className="font-p mt-5 pb-4">
                    Thank you for your kind support. We will be in touch with you shortly.
                </p>
            </form>
        </div>
    )
}

export default DammaSermonsRequest